module.exports = __webpack_public_path__ + "img/chat-mail.41a671db.svg";